import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxGroupRootFn = /* @__PURE__ */ createRecipe('checkbox-group-root', {}, [])

const checkboxGroupRootVariantMap = {}

const checkboxGroupRootVariantKeys = Object.keys(checkboxGroupRootVariantMap)

export const checkboxGroupRoot = /* @__PURE__ */ Object.assign(memo(checkboxGroupRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxGroupRoot',
  __getCompoundVariantCss__: checkboxGroupRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxGroupRootVariantKeys,
  variantMap: checkboxGroupRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxGroupRootVariantKeys)
  },
  getVariantProps: checkboxGroupRootFn.getVariantProps,
})